export const card = {
  MuiCardContent: {
    root: {
      "&:last-child": {
        paddingBottom: 0,
      },
    },
  },
};
